import React from "react";
import { Box } from "@mui/material";
import NightsStayIcon from "@mui/icons-material/NightsStay";

const NightsStayedIcon = ({ nights }) => {
    const safeNights = Number.isFinite(nights) && nights > 0 ? nights : 0;

    return (
        <Box
            sx={{
                width: 44,
                height: 44,
                borderRadius: 1.5,
                overflow: "hidden",
                border: 2,
                borderColor: "secondary.main",
                textAlign: "center",
                bgcolor: "background.paper",
                boxShadow: 0,
                display: "flex",
                flexDirection: "column",
            }}
            aria-hidden
        >
            <Box
                sx={{
                    bgcolor: "secondary.main",
                    color: "common.white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: "0 0 40%",
                }}
            >
                <NightsStayIcon sx={{ fontSize: "1rem" }} />
            </Box>
            <Box
                sx={{
                    color: "text.primary",
                    fontWeight: 700,
                    fontSize: "1rem",
                    lineHeight: 1,
                    flex: "1 1 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {safeNights}
            </Box>
        </Box>
    );
};

export default NightsStayedIcon;
